<template>
  <div class="solicitudEmpleo" style="margin-top:90px;">
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center">
          <span class="d-block titles pb-6">Solicitud de empleo</span>
          <span class="d-block texts max-width-10">
            Gracias por su interés en trabajar con nosotros. Por favor observe aquí abajo las oportunidades laborales
            que se adapten a sus criterios y envíe su petición completando este formulario de solicitud de empleo.
          </span>
        </v-col>
      </v-row>

      <!-- ****************Formulario*********** -->

      <v-row justify="center" class="mt-5">
        <v-col cols="10" md="7">
          <v-form id="jobApplicationForm" ref="jobApplicationForm" lazy-validation v-model="valid">
            <v-row justify="center">
              <v-col cols="auto">
                <span class="subtitles">Información del contacto</span>
              </v-col>
            </v-row>

            <!-- ****************Nombre*********** -->
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field label="Nombre" v-model="name" v-bind:rules="nameRules"></v-text-field>
              </v-col>
            </v-row>
            <!-- ****************/Nombre*********** -->

            <!-- ****************Teléfono*********** -->
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field label="Teléfono" v-model="phone" v-bind:rules="phoneRules"></v-text-field>
              </v-col>
            </v-row>
            <!-- ****************/Teléfono*********** -->

            <!-- ****************Correo*********** -->
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field label="Correo" v-model="email" v-bind:rules="emailRules"></v-text-field>
              </v-col>
            </v-row>
            <!-- ****************/Correo*********** -->

            <!-- ****************Puesto*********** -->
            <v-row justify="center">
              <v-col cols="auto" class="text-center">
                <span class="subtitles d-block mb-4">Puesto</span>

                <v-select
                  v-model="jobPositionSelect"
                  v-bind:items="jobPositionsItems"
                  v-bind:rules="jobPositionRules"
                  menu-props="auto"
                  hide-details
                  label="Outlined style"
                  solo
                  flat
                  id="select"
                  style="width: 350px; border: 1px solid black; border-radius:60px;"
                  light
                  dense
                  background-color="white"
                  color="white"
                ></v-select>
              </v-col>
            </v-row>
            <!-- ****************/Puesto*********** -->

            <!-- ****************Situación laboral*********** -->
            <v-row class="pt-4" justify="center">
              <v-col cols="auto" class="pb-0">
                <span class="subtitles">¿Cuál es tu situación laboral actual?</span>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-radio-group
                  v-model="employmentSituation"
                  v-bind:rules="employmentSituationRules"
                >
                  <v-row justify="center">
                    <v-col cols="auto">
                      <v-row>
                        <v-col cols="auto">
                          <v-radio label="Empleado" value="Empleado"></v-radio>
                          <v-radio label="Desempleado" value="Desempleado"></v-radio>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="auto">
                      <v-row>
                        <v-col cols="auto">
                          <v-radio label="Particular" value="Particular"></v-radio>
                          <v-radio label="Estudiante" value="Estudiante"></v-radio>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- ****************/Situación laboral*********** -->

            <!-- ****************CV*********** -->
            <v-row justify="center">
              <v-col cols="auto" class="pb-0">
                <span class="subtitles">CV*</span>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-file-input
                  v-model="files"
                  v-bind:rules="fileRules"
                  label="Elegir archivo"
                  style="width: 350px;"
                  outlined
                  dense
                  accept=".pdf"
                  class="mx-auto"
                  multiple
                  chips
                ></v-file-input>

                <span>*Solo se aceptan archivos pdf</span>
              </v-col>
              <v-col cols="auto">
                <ul class="d-flex pl-0 align-center">
                  <li>
                    <v-btn elevation="0" fab x-small :ripple="false">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </li>
                  <li class="pl-2">
                    <span>Adjuntar elementos adicionales</span>
                  </li>
                </ul>
              </v-col>
              <v-col cols="auto">
                <ul class="d-flex pl-0 align-center">
                  <li>
                    <v-btn elevation="0" fab x-small :ripple="false">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </li>
                  <li class="pl-2">
                    <input class="d-none" ref="filePresentationCard" type="file" name id />
                    <!-- @click="addFiles()" -->
                    <span>Añadir carta de presentación</span>
                    <span id="presentationCard" class="d-block"></span>
                  </li>
                </ul>
              </v-col>
            </v-row>
            <!-- ****************/CV*********** -->

            <!-- ****************Mensaje*********** -->
            <v-row class="pt-4">
              <v-col cols="12" class="pb-0">
                <span class="subtitles">Mensaje</span>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  solo
                  outlined
                  flat
                  no-resize
                  v-model="message"
                  v-bind:rules="messageRules"
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- ****************/Mensaje*********** -->

            <!-- ****************Aceptar Aviso de privacidad*********** -->
            <v-row>
              <v-col cols="12" class="text-center">
                <v-row justify="center">
                  <!-- <v-col cols="auto" class="align-self-center">
                    <v-checkbox v-model="noticePrivacity" id="noticePrivacity"></v-checkbox>
                  </v-col>
                  <v-col cols="auto" class="align-self-center">
                    <label
                      style="text-decoration: underline; cursor:pointer;"
                      for="avisoPrivacidad"
                    >Acepto el aviso de privacidad</label>
                  </v-col>-->
                  <v-col cols="12">
                    <span class="d-block">
                      Cualquier duda llamar.
                      Tel. 81.8342.2000
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- ****************/Aceptar Aviso de privacidad*********** -->

            <!-- ****************botón de enviar*********** -->
            <v-row class="pb-10">
              <v-col class="text-center">
                <v-btn
                  @click="validate()"
                  :disabled="!valid"
                  elevation="0"
                  width="250"
                  color="#B40000"
                  class="notUppercase"
                >
                  <span class="white--text texts">Enviar</span>
                </v-btn>
              </v-col>
            </v-row>
            <!-- ****************/botón de enviar*********** -->
          </v-form>
        </v-col>
      </v-row>
      <!-- ****************/Formulario*********** -->

      <!-- *********************inicia alerta de mensaje enviado************* -->
      <v-snackbar v-model="send" :timeout="timeSend" id="snackbarSend" color="black">
        <span>{{text}}</span>

        <v-btn color="white" text @click="send = false" :ripple="false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <!-- *********************termina alerta de mensaje enviado************* -->
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {
  data: () => ({
    //form
    valid: true,

    //Message send 'snackbar'
    send: false,
    text: "Tu solicitud de empleo ha sido enviada.",
    timeSend: 12000,

    //textfields and rules
    name: "",
    nameRules: [
      (v) => !!v || "Campo requerido",
      (v) => /^[a-zA-Z-áéíóúÁÉÍÓÚ\s]+$/.test(v) || "Solo se permiten letras",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "Campo requerido",
      (v) => /^[0-9]+$/.test(v) || "Teléfono no válido",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "Campo requerido",
      (v) => /.+@.+\..+/.test(v) || "Email no válido",
    ],
    jobPositionsItems: [],
    jobPositionSelect: "",
    jobPositionRules: [(v) => !!v || "Debes seleccionar una opción"],
    employmentSituation: "",
    employmentSituationRules: [(v) => !!v || "Debes seleccionar una opción"],
    files: [],
    fileRules: [(v) => !!v || "Debes agregar un archivo"],
    message: "",
    messageRules: [(v) => !!v || "Campo requerido"],
    noticePrivacity: false,
  }),
  beforeMount() {
    var aux = this;

    //get the jobPositions
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/jobPositions?token=16db21f0656450d15b7ee93d559638"
    )
      .then((res) => res.json())
      .then(function (res) {
        //set the first job position to the v-model select
        aux.jobPositionSelect = res.entries[0].position;

        //set all the job positions to the select
        for (let index = 0; index < res.entries.length; index++) {
          const element = res.entries[index];
          // console.log(element.position);
          aux.jobPositionsItems.push(element.position);
        }
      })
      .catch((error) => console.log(error.message));
  },
  mounted: function () {
    this.$emit("update", 1);
  },
  methods: {
    validate() {
      if (this.$refs.jobApplicationForm.validate()) {
        this.upload();

        //activate toast
        this.send = true;

        //reset the textfields value
        // this.$refs.jobApplicationForm.reset();
      }
    },
    upload: function () {
      var aux = this;

      let datos = new FormData();

      for (let index = 0; index < this.files.length; index++) {
        datos.append("files[" + index + "]", this.files[index]);
      }

      // datos.append("name", "my-file");
      // datos.append("files[0]", this.files[0]);
      // console.log(datos);

      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      axios
        .post(
          "https://www.mlcpcms.actstudio.xyz/api/cockpit/addAssets?token=16db21f0656450d15b7ee93d559638",
          datos,
          config
        )
        .then(function (res) {
          console.log(res);
          var routes = [];

          for (let index = 0; index < res.data.assets.length; index++) {
            const element = res.data.assets[index].path;
            routes.push(element);
            // console.log(element);
          }

          // var ruta = res.data.assets[0].path;
          // console.log(ruta);

          // var routesJoin = routes.join('\n');

          // for (var x = 0; x < routes.length; x++) {
          //   const element = routes[x];
          // }


          //object with info to send
          var form_jobApplication = {
            Nombre: aux.name,
            Teléfono: aux.phone,
            Correo: aux.email,
            Puesto: aux.jobPositionSelect,
            SituaciónLaboral: aux.employmentSituation,
            Mensaje: aux.message,
            CV: "https://www.mlcpcms.actstudio.xyz/storage/uploads" + routes[0],
          };
            // Files:[]

          // for (let fj = 0; fj < routes.length; fj++) {
          //   const element = routes[fj];
            
          //   form_jobApplication.Files.push("hola", "hola");
          // }

          console.log(form_jobApplication);

          fetch(
            "https://www.mlcpcms.actstudio.xyz/api/forms/submit/jobApplicationForm?token=16db21f0656450d15b7ee93d559638",
            {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                form: form_jobApplication,
              }),
            }
          )
            .then((entry) => entry.json())
            .then((entry) => console.log(entry));
        });
    },
    addFiles: function (e) {
      this.$refs.filePresentationCard.click();
      console.log(this.$refs.jobApplicationForm.$el.filePresentationCard);

      // var file = e.target.files[0].name;
      // presentationCard.innerHTML = e.target.files[0].name;
      // this.files.push(e.target.files[0]);
    },
  },
};
</script>